import React, { useCallback, useState } from "react";
import { Header } from "build-ts/metadata";
import { ScheduledJobProto } from "build-ts/schedule";
import JobDetailView from "modules/analyst/components/JobDetailView";

interface JobDetailViewContainerProps {
  onBack: () => void;
  selectedJob?: Header;
  onJobNameChange?: (newName: string) => void;
  /** Pre-fetched full proto — forwarded to WorkflowDefinitionContainer to skip a redundant API call. */
  initialJobDetails?: ScheduledJobProto;
  /** When provided, tabs are URL-driven — the container owns the active index. */
  activeTab?: number;
  onTabChange?: (idx: number) => void;
}

const JobDetailViewContainer: React.FC<JobDetailViewContainerProps> = props => {
  const [darwinName, setDarwinName] = useState<string>("");
  const [refreshCounter, setRefreshCounter] = useState<number>(0);

  const handleWorkflowSaved = useCallback(() => {
    setRefreshCounter(c => c + 1);
  }, []);

  return (
    <JobDetailView
      {...props}
      darwinName={darwinName}
      setDarwinName={setDarwinName}
      onWorkflowSaved={handleWorkflowSaved}
      refreshCounter={refreshCounter}
    />
  );
};

export default JobDetailViewContainer;
